// import external dependencies
import 'reframe.js/dist/reframe.js';
import 'lity/dist/lity.js';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import product from './routes/product';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  product,
});

// Load Events
routes.loadEvents();
